import { render, staticRenderFns } from "./DaysInStock.vue?vue&type=template&id=399def32&"
import script from "./DaysInStock.vue?vue&type=script&lang=js&"
export * from "./DaysInStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports